// C.1 — Полковник Мит (global_mit), архетип «Зерг G-Sec».
//
// Этап 31: триггер изменён — раз в 3 хода (ходы 3, 6, 9, …) вместо
// каждого хода со 2-го. xlsx обновлён аналогично.
//
// xlsx v6 dsl_trigger1:
//   event: turn_end, target: own_line, effect: summon, value: global_gsec_fighter
//   condition: turn_number_multiple_of_3
//   → В конце ходов 3, 6, 9, …: призвать Бойца G-Sec на свободную ячейку
//     своей линии.
//
// dsl_active (Ф2, 1× за матч) — Этап 56.24 (изменено по запросу):
//   target: random_empty_slots, effect: summon, value: global_gsec_fighter@count:4
//   → Призвать 4 Бойцов G-Sec, каждого на СЛУЧАЙНУЮ свободную ячейку своей
//     стороны. Если свободных меньше 4 — призвать сколько есть.
//   (Раньше: заполнить ВСЕ свободные ячейки.)

import { registerImplementedAbility } from '../../warn-unimplemented.js';
import { summonUnit } from '../summon.js';

export const HERO_ID = 'global_mit';
const GSEC_FIGHTER_ID = 'global_gsec_fighter';

// Конец хода — призвать одного Бойца G-Sec.
// Этап 31: только на ходах кратных 3 (3, 6, 9, …).
export function mitOnEndOfTurn(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return;
  if (p.hero.current?.silenced) return;
  const turn = state.currentTurn ?? 0;
  if (turn < 3 || turn % 3 !== 0) return;
  // Свободный слот: сначала линия 1 (фронт), потом линия 2.
  for (let line = 0; line < 2; line++) {
    const row = p.field?.[line] || [];
    for (let s = 0; s < row.length; s++) {
      if (row[s] === null) {
        const unit = summonUnit(state, playerIdx, GSEC_FIGHTER_ID, line, s);
        if (unit && state.log) {
          state.log.add(`🪖 Мит [${p.name}]: призван Боец G-Sec на (${line + 1}, ${s + 1})`);
        }
        return;
      }
    }
  }
}

// Активка Ф2 (Этап 56.24): призвать 4 Бойцов, каждого на СЛУЧАЙНУЮ
// свободную ячейку своей стороны. Меньше 4 свободных → сколько есть.
const MIT_ACTIVE_COUNT = 4;
export function mitActive(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return { ok: false, reason: 'wrong_hero' };
  if (p.heroActiveUsedThisMatch) return { ok: false, reason: 'already_used' };

  let summoned = 0;
  for (let i = 0; i < MIT_ACTIVE_COUNT; i++) {
    // Пересобираем список свободных ячеек на каждой итерации (после призыва
    // одна занялась) и выбираем случайную через детерминированный RNG движка.
    const free = [];
    for (let line = 0; line < 2; line++) {
      const row = p.field?.[line] || [];
      for (let s = 0; s < row.length; s++) if (row[s] === null) free.push({ line, slot: s });
    }
    if (free.length === 0) break; // свободных не осталось
    const pickIdx = state.rng?.int ? state.rng.int(free.length) : Math.floor(Math.random() * free.length);
    const cell = free[pickIdx];
    const unit = summonUnit(state, playerIdx, GSEC_FIGHTER_ID, cell.line, cell.slot);
    if (unit) {
      summoned++;
      if (state.log) {
        state.log.add(`🪖 Мит [${p.name}]: Боец G-Sec призван на случайную ячейку (${cell.line + 1}, ${cell.slot + 1})`);
      }
    }
  }
  p.heroActiveUsedThisMatch = true;
  if (state.log) {
    state.log.add(`🪖 Мит [${p.name}]: активка — призвано ${summoned}/${MIT_ACTIVE_COUNT} Бойцов G-Sec (случайные ячейки)`);
  }
  return { ok: true, summoned };
}

export function mitActiveAvailable(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsedThisMatch) return false;
  if (p.hero.current?.silenced) return false;
  // Хоть одна свободная ячейка.
  for (let line = 0; line < 2; line++) {
    const row = p.field?.[line] || [];
    for (const slot of row) if (slot === null) return true;
  }
  return false;
}

registerImplementedAbility(HERO_ID, 'trigger', 'active');
